import React, { createContext, ReactNode } from 'react';
import clsx from 'clsx';
import { ChevronLeftIcon, TimesIcon } from '../Icon';
import Loader from '../Loader';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';

import {
  Wrapper,
  PanelHead,
  PanelTitle,
  PanelClose,
  PanelBody,
  PanelFooter,
  UiBlock,
  BackButton,
} from './wrappers';

interface IPanelContext {
  scrollContainerRef: React.MutableRefObject<HTMLDivElement | null>;
}

const PanelContext = createContext<IPanelContext | undefined>(undefined);

interface IPanel {
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
  hideHead?: boolean;
  fixedWidth?: boolean;
  loading?: boolean;
  onClose?: () => void;
  smallTitle?: boolean;
  title?: string;
  zIndex?: number;
  noScrollLock?: boolean;
  onBackClick?: () => void;
}

const Panel = ({
  children,
  className,
  footer,
  hideHead,
  fixedWidth,
  loading,
  onClose,
  smallTitle,
  title,
  zIndex,
  noScrollLock,
  onBackClick,
}: IPanel) => {
  const bodyRef = useBodyScrollLock<HTMLDivElement>({ condition: !noScrollLock });

  return (
    <>
      <Wrapper className={className} style={zIndex ? { zIndex } : undefined}>
        <PanelHead
          className={(hideHead && 'no-padding') || (fixedWidth && 'fixedWidth') || undefined}>
          {title && (
            <PanelTitle className={(smallTitle && 'small') || undefined}>{title}</PanelTitle>
          )}

          {!!onBackClick && (
            <BackButton onClick={onBackClick}>
              <ChevronLeftIcon />
              Tillbaka
            </BackButton>
          )}

          <PanelClose
            onClick={onClose}
            title="Stäng panel"
            className={(hideHead && 'float') || undefined}>
            <TimesIcon />
          </PanelClose>
        </PanelHead>
        <PanelBody
          className={clsx((loading && 'is-loading') || (fixedWidth && 'fixedWidth'))}
          ref={bodyRef}>
          {loading && <Loader />}
          {!loading && (
            <PanelContext.Provider value={{ scrollContainerRef: bodyRef }}>
              {children}
            </PanelContext.Provider>
          )}
        </PanelBody>
        {footer && <PanelFooter>{footer}</PanelFooter>}
      </Wrapper>
      <UiBlock onClick={onClose} title="Stäng panel" aria-label="Stäng panel" />
    </>
  );
};

export default Panel;
